import React, { lazy } from 'react';

import { useSelector } from '@lumapps/redux/react';
import { Suspense } from '@lumapps/utils/components/Suspense';

import { showAgentDrawerChatSelector } from '../../ducks/selectors';
import type { AiAgentsChatWithButtonProps } from './AiAgentsChatWithButton';

const LazyAiAgentsChat = lazy(
    () =>
        import(
            /* webpackChunkName: 'ai-agents-chat-with-button' */
            './AiAgentsChatWithButton'
        ),
);

export const AiAgentsChatWithButton: React.FC<AiAgentsChatWithButtonProps> = ({ showButton }) => {
    const isAllowed = useSelector(showAgentDrawerChatSelector);

    if (!isAllowed) {
        return null;
    }

    return (
        <Suspense>
            <LazyAiAgentsChat showButton={showButton} />
        </Suspense>
    );
};
